var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logoutIcon",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgLogout{fill:#B5B5B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-out_2_",
    transform: "translate(-135.111 -82.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    className: "svgLogout svgBase svgHover svgSelect",
    d: "M144.1,99.6c-4.3-0.1-7.8-3.6-7.7-7.9c0-2.9,1.7-5.6,4.3-6.9c0.3-0.1,0.6,0,0.8,0.3c0,0,0,0,0,0 c0.1,0.3,0,0.6-0.3,0.8c-3.3,1.6-4.7,5.6-3.1,8.8c1.6,3.3,5.6,4.7,8.8,3.1c3.3-1.6,4.7-5.6,3.1-8.8c-0.6-1.3-1.7-2.4-3.1-3.1 c-0.3-0.1-0.4-0.5-0.3-0.8c0.1-0.3,0.5-0.4,0.8-0.3c0,0,0,0,0,0c3.9,1.9,5.5,6.6,3.5,10.5C149.7,97.9,147.1,99.6,144.1,99.6 L144.1,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    className: "svgLogout svgBase svgHover svgSelect",
    d: "M144.1,83c0.3,0,0.6,0.2,0.6,0.6V89c0,0.3-0.3,0.5-0.6,0.5c-0.3,0-0.5-0.2-0.5-0.5v-5.5 C143.6,83.2,143.8,83,144.1,83z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.9afdf667.svg";
export { ForwardRef as ReactComponent };